import qs from 'qs';
import url from 'url';

/**
 * Build URL for catalogue page
 *
 * @param {number} uid Sales venue UID
 * @param {string} date Sales start date YYYY-MM-DD
 * @param {object} [queryParams]
 * @returns {string} URL
 */
export function catalogueUrl(uid, date, queryParams = null) {
    let catUrl = `catalogues/${uid}/${date}`;
    if (queryParams) {
        catUrl += `?${qs.stringify(queryParams)}`;
    }

    return catUrl;
}

/**
 * Build URL for statistics page
 *
 * @param {number} uid Sales venue UID
 * @param {string} date Sales start date YYYY-MM-DD
 * @returns {string} URL
 */
export function statisticsUrl(uid, date) {
    return `statistics/${uid}/${date}`;
}

/**
 * Build URL to concrete lot
 *
 * @param {number} uid Sales venue UID
 * @param {string} date Sales start date YYYY-MM-DD
 * @param {number} lot Lot number
 * @param {string} letter Lot letter
 * @returns {string} URL
 */
export function lotUrl(uid, date, lot, letter) {
    return `catalogues/${uid}/${date}?lot=${lot}&letter=${encodeURIComponent(letter)}`;
}

/**
 * Build URL to horses/humans profiles
 *
 * @param {string} type Profile type
 * @param {number} id Profile ID
 * @param {string} name Profile style name
 * @returns {string}
 */
export function profileUrl(type, id, name) {
    if (!type || !id || !name) {
        return '';
    }

    const urlName = name
        .toLowerCase()
        .replace(/[^\w\s\-]/g, '')
        .replace(/[\s_]+/g, '-');

    return `/profile/${type}/${id}/${urlName}`;
}

/**
 * Build URL to race card
 *
 * @param {number} courseId courseId
 * @param {string} courseName courseName
  * @param {string} raceDate raceDate
 * @param {number} raceId raceId
 * @returns {string}
 */
export function raceUrl(courseId, courseName, raceDate, raceId) {
    if (!courseId || !courseName || !raceDate || !raceId) {
        return '';
    }

    const urlName = courseName
        .toLowerCase()
        .replace(/[^\w\s\-]/g, '')
        .replace(/[\s_]+/g, '-');

    return `/racecards/${courseId}/${urlName}/${raceDate}/${raceId}`;
}

/**
 * Build URL with given query params
 *
 * @param {string} baseUrl
 * @param {{}} params Query parameters
 * @returns {string}
 */
export function queryUrl(baseUrl, params) {
    const parsedUrl = url.parse(baseUrl);
    const query = qs.parse(parsedUrl.query || parsedUrl.search);

    return url.format(
        Object.assign(parsedUrl, {
            search: qs.stringify(Object.assign(query, params))
        })
    );
}



// WEBPACK FOOTER //
// ./src/js/helpers/urlBuilder.js